import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import style from './Curtains.module.scss';
import { CurtainsYellowDetails } from "./CurtainsConstant";
import { saveUpdatedPageDetails, saveMetaDataUpdate } from "../../../actions/wizard";
import defaultImage from '../../../assets/default.png';

const CurtainsYellow = (props: any) => {
  const dispatch = useDispatch();
  const { isDrawingsExporting } = props;
  const pageDetails = useSelector((state: any) => state.wizard.pageDetails);
  const requiredMetaDataUpdate = useSelector((state: any) => state.wizard.requiredMetaDataUpdate);

  const latestStateRef = useRef(requiredMetaDataUpdate);

  const [updatedValues, setUpdatedValues] = useState(pageDetails);

  useEffect(() => {
    setUpdatedValues(pageDetails)
  }, [pageDetails]);

  // Update the meta details while unmounting.
  useEffect(() => {
    return () => {
      updateDetailsInMeta(false);
    }
  }, [])

  // Updating Item details in meta data
  const updateItems = (details: any) => {
    const updatedObj: any = {
      ...updatedValues,
      metaData: {
        ...updatedValues?.metaData,
        [details.id]: details.value
      }
    };
    setUpdatedValues(updatedObj)
    dispatch(saveMetaDataUpdate(updatedObj))
  }

  // Save function to save details in API
  const updateDetailsInMeta = (required: boolean) => {
    if (latestStateRef.current) {
      dispatch(saveUpdatedPageDetails(latestStateRef.current, required));
      dispatch(saveMetaDataUpdate(false))
    }
  }

  // Created a debounce to update the exiting quote details 
  useEffect(() => {
    const debounceTimer = setTimeout(() => {
      updateDetailsInMeta(true);
    }, 4000); // Adjust the delay (in milliseconds) as needed

    latestStateRef.current = requiredMetaDataUpdate;

    return () => {
      clearTimeout(debounceTimer);
    };
  }, [requiredMetaDataUpdate]);

  const panelDetails = updatedValues?.curtainsDetails?.length ? updatedValues?.curtainsDetails : CurtainsYellowDetails;

  return (
    <section className={style.curtains_room_container}>
      <h2 className="section_heading">{updatedValues?.name}</h2>
      <div className={style.curtains_details_tabs}>
        <div className={style.curtains_work_image_columns}>
          <section style={{ gridTemplateRows: '1fr max-content 1fr' }}>
            <div className={style.left_image_section}>
              <p>Key Plan of the House / <br /> Site Photograph of the Room</p>
            </div>
            <hr />
            <div className={style.left_image_section}>
              {updatedValues?.images?.length ? <img crossOrigin="anonymous" src={updatedValues?.images[0] ? `${updatedValues?.images[0]}?ver=${new Date().getTime()}`: defaultImage} alt="" style={{ maxHeight: updatedValues?.images?.length > 1 ? '170px' : '190px' }} className="image-view" /> : <p>Fabric Image(s)</p>}
            </div>
          </section>
          <section>
            <div>
              <p>Window Elevation with</p>
              <p>a) Overall Window Dimensions (X & Y Axis); </p>
              <p>b) Overall Curtain Dimensions (X+10" & Y+10")</p>
              <span>Designer to denote each panel as (Panel Code A,B, C, D etc.) with Legend Below:</span>
              <p>Panel A: Panel Dimension: Panel Size (Width & Height): Panel Fabric</p>
            </div>
            {
              updatedValues?.curtainsDetails?.some((e: any) => e?.designType) ? (
                <div className={style.right_image_section} style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', borderTop: ' 1px solid #BDC1CA', height: '25%' }}>
                  {updatedValues?.curtainsDetails?.map((e: any, i: number) => (
                    <div style={{ borderRight: '1px solid #BDC1CA' }}>
                      <p style={{ marginTop: '20px' }}>{e?.['wall_orientation_'+i]}</p>
                      <img key={i} src={e?.designType ? `${e?.designType}?ver=${new Date().getTime()}` : defaultImage} alt="" style={{ maxHeight: '170px' }} className="image-view" />
                    </div>
                  ))}
                </div>
              ) : ''
            }
          </section>
        </div>
        <div className={style.curtains_item_container}>
          <h2 className="sub_tab_heading">{updatedValues?.curtainsDetails?.[0]?.heading ? updatedValues?.curtainsDetails?.[0]?.heading : 'Curtains Details'}</h2>
          <div className={style.demolition_item_details_panel}>
            <div className={style.curtains_details_tabs_7_col}>
              <h4>Product Name</h4>
              <h4>Wall Orientation</h4>
              <h4>Panel Quantity</h4>
              <h4>Header Type</h4>
              <h4>Lining</h4>
              <h4>Curtain Height Alterations</h4>
              <h4>Curtain Height in mm (for Alterations)</h4>
            </div>
            <div className={`${style.curtains_items_list} ${style.curtains_details_tabs_7_col}`}>
              {
                panelDetails?.map((e, i) => (
                  <>
                    <p>
                      <div className={style.option_view}>
                        {!isDrawingsExporting ? <input value={updatedValues?.metaData?.[`fabric_name_${i}`] || e?.[`fabric_name_${i}`] || ''} onChange={(v) => updateItems({ id: `fabric_name_${i}`, value: v.target.value })} /> : <span>{updatedValues?.metaData?.[`fabric_name_${i}`] || e?.[`fabric_name_${i}`] || '-'}</span>}
                      </div>
                    </p>
                    <p>
                      <div className={style.option_view}>
                        {!isDrawingsExporting ? <input value={updatedValues?.metaData?.[`wall_orientation_${i}`] || e?.[`wall_orientation_${i}`] || ''} onChange={(v) => updateItems({ id: `wall_orientation_${i}`, value: v.target.value })} /> : <span>{updatedValues?.metaData?.[`wall_orientation_${i}`] || e?.[`wall_orientation_${i}`] || '-'}</span>}
                      </div>
                    </p>
                    <p>
                      <div className={style.option_view}>
                        {!isDrawingsExporting ? <input value={updatedValues?.metaData?.[`quantity_${i}`] || e?.[`quantity_${i}`] || ''} onChange={(v) => updateItems({ id: `quantity_${i}`, value: v.target.value })} /> : <span>{updatedValues?.metaData?.[`quantity_${i}`] || e?.[`quantity_${i}`] || '-'}</span>}
                      </div>
                    </p>
                    <p>
                      <div className={style.option_view}>
                        {!isDrawingsExporting ? <input value={updatedValues?.metaData?.[`hardware_type_${i}`] || e?.[`hardware_type_${i}`] || ''} onChange={(v) => updateItems({ id: `hardware_type_${i}`, value: v.target.value })} /> : <span>{updatedValues?.metaData?.[`hardware_type_${i}`] || e?.[`hardware_type_${i}`] || '-'}</span>}
                      </div>
                    </p>
                    <p>
                      <div className={style.option_view}>
                        {!isDrawingsExporting ? <input value={updatedValues?.metaData?.[`lining_${i}`] || e?.[`lining_${i}`] || ''} onChange={(v) => updateItems({ id: `lining_${i}`, value: v.target.value })} /> : <span>{updatedValues?.metaData?.[`lining_${i}`] || e?.[`lining_${i}`] || '-'}</span>}
                      </div>
                    </p>
                    <p>
                      <div className={style.option_view}>
                        {!isDrawingsExporting ? <input value={updatedValues?.metaData?.[`curtains_height_${i}`] || e?.[`curtains_height_${i}`] || ''} onChange={(v) => updateItems({ id: `curtains_height_${i}`, value: v.target.value })} /> : <span>{updatedValues?.metaData?.[`curtains_height_${i}`] || e?.[`curtains_height_${i}`] || '-'}</span>}
                      </div>
                    </p>
                    <p>
                      <div className={style.option_view}>
                        {!isDrawingsExporting ? <input value={updatedValues?.metaData?.[`curtain_height_inMM_${i}`] || e?.[`curtain_height_inMM_${i}`] || ''} onChange={(v) => updateItems({ id: `curtain_height_inMM_${i}`, value: v.target.value })} /> : <span>{updatedValues?.metaData?.[`curtain_height_inMM_${i}`] || e?.[`curtain_height_inMM_${i}`] || '-'}</span>}
                      </div>
                    </p>
                  </>
                ))
              }
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default CurtainsYellow;